export default __webpack_public_path__ + "static/media/472.23d2f7b4.png";